var _defs, _defs2, _defs3, _defs4, _defs5, _defs6, _defs7, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _circle20, _rect, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgJd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 650 600",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 0,
    width: 40,
    height: 300,
    style: {
      fill: "url(&quot"
    }
  }), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "topGradient",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ec271c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#dc5e2d"
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 300,
    width: 40,
    height: 300,
    style: {
      fill: "url(&quot"
    }
  }), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bottomGradient",
    x1: "0%",
    y1: "0%",
    x2: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#271b78"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#332aa3"
  })))), /*#__PURE__*/React.createElement("rect", {
    x: 305,
    y: 504,
    width: 16,
    height: 96,
    style: {
      fill: "rgb(1, 185, 212)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 300,
    width: 325,
    height: 24,
    style: {
      fill: "rgb(253, 121, 17)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325,
    y: 300,
    width: 325,
    height: 24,
    style: {
      fill: "rgb(241, 7, 81)"
    }
  }), _defs3 || (_defs3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "yellowGradient",
    gradientTransform: "rotate(90)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fbdf00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "50%",
    stopColor: "#feaf02"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fbdf00"
  })))), _defs4 || (_defs4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "orangeGradient",
    gradientTransform: "rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fd7c0c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f82a35"
  })))), _defs5 || (_defs5 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "orangeGradient2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f03536"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#fd7e10"
  })))), _defs6 || (_defs6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "redGradient",
    gradientTransform: "rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#f41946"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#f60f46"
  })))), /*#__PURE__*/React.createElement("polygon", {
    points: "501,192, 613,192, 613,224, 597,224, 597,232, 501,232, ",
    style: {
      fill: "rgb(255, 196, 1)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "453,160, 461,160, 461,144, 469,144, 469,80, 501,80, 501,192, 525,192, 525,216, 557,216, 557,232, 517,232, 517,240, 325,240, ",
    style: {
      fill: "url(&quot"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "413,112, 345,112, 345,184, 445,184, 445,176, 453,176, 453,160, 445,160, 445,144, 437,144, 437,128, 413,128, ",
    style: {
      fill: "url(&quot"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305,0, 345,0, 345,72, 373,72, 373,68, 397,68, 397,96, 413,96, 413,112, 377,112, 377,144, 349,144, 349,168, 345,168, 345,200, 229,200, 229,144, 301,96, 305,96, ",
    style: {
      fill: "url(&quot"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "200,124, 80,124, 80,156, 96,156, 96,172, 40,172, 40,204, 16,204, 16,220, 80,220, 80,252, 16,252, 16,268, 200,268, ",
    style: {
      fill: "url(&quot"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "305,300, 96,300, 96,276, 136,276, 136,228, 152,228, 152,180, 176,180, 176,148, 200,148, 200,124, 240,124, 240,60, 272,60, 272,92, 305,92, 305,108, 285,108, 285,140, 261,140, 261,148, 229,148, 229,300, ",
    style: {
      fill: "url(&quot"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "16,204, 16,172, 48,172, 48,204, ",
    style: {
      fill: "rgb(255, 201, 0)"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325,
    y: 284,
    width: 325,
    height: 16,
    style: {
      fill: "rgb(245, 91, 27)"
    }
  }), _defs7 || (_defs7 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "blueGradient",
    gradientTransform: "rotate(-90)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00a2ca"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#02d0e5"
  })))), /*#__PURE__*/React.createElement("polygon", {
    points: "305,504, 305,344, 69,344, 69,368, 165,368, 165,536, 197,536, 197,520, 269,520, 269,456, 293,456, 293,504, ",
    style: {
      fill: "url(&quot"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "325,368, 37,368, 37,384, 130,384, 130,408, 82,408, 82,440, 106,440, 106,488, 130,488, 130,408, 138,408, 138,440, 170,440, 170,432, 194,432, 194,408, 389,408, 389,536, 405,536, 405,512, 421,512, 421,408, ",
    style: {
      fill: "rgb(43, 28, 124)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "525,496, 525,432, 549,432, 549,400, 573,400, 573,384, 501,384, 501,360, 485,360, 485,496, ",
    style: {
      fill: "rgb(213, 0, 185)"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37,384, 37,368, 29,368, 29,384, 5,384, 5,400, 345,400, 345,384, 345,456, 357,456, 357,504, 405,504, 405,496, 517,496, 517,440, 493,440, 493,384, ",
    style: {
      fill: "rgb(139, 0, 167)"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 413,
    cy: 300,
    rx: 120,
    style: {
      fill: "black"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233,
    y: 180,
    width: 184,
    height: 240,
    style: {
      fill: "black"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "229,164 301,156 301,420 229,420",
    style: {
      fill: "black"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "112,324 325,324 325,388 96,388",
    style: {
      fill: "black"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "120,388 325,388 325,420 112,420",
    style: {
      fill: "black"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,284C169.16666666666666,311.3333333333333,104,316.6666666666667,112,330C120,343.3333333333333,217.16666666666666,391.3333333333333,237,364C256.8333333333333,336.6666666666667,239,179.33333333333334,231,166C223,152.66666666666666,208.83333333333334,256.6666666666667,189,284",
    style: {
      fill: "black"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 397,
    cy: 292,
    rx: 104,
    ry: 96,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301,
    y: 180,
    width: 40,
    height: 240,
    style: {
      fill: "black"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 293,
    y: 252,
    width: 40,
    height: 80,
    style: {
      fill: "black"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 397,
    cy: 292,
    rx: 48,
    ry: 48,
    style: {
      fill: "black"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341,
    y: 196,
    width: 56,
    height: 192,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 277,
    y: 316,
    width: 72,
    height: 72,
    style: {
      fill: "white"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 277,
    cy: 320,
    rx: 64,
    ry: 72,
    style: {
      fill: "black"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269,172C269,172,251.66666666666666,316,229,348C206.33333333333334,380,133,364,133,364",
    style: {
      stroke: "white",
      strokeWidth: 64
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 229,
    y: 164,
    width: 72,
    height: 17.6,
    style: {
      fill: "black"
    }
  }), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    r: 8,
    fill: "#ffd200",
    cx: 195,
    cy: 84
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fill: "#fc9610",
    cx: 240.66666666666666,
    cy: 40
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    r: 6,
    fill: "#fb4c23",
    cx: 400,
    cy: 42.857142857142854
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    r: 2,
    fill: "#fb4c23",
    cx: 64,
    cy: 142.85714285714286
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    r: 2,
    fill: "#fb4c23",
    cx: 424,
    cy: 75
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    r: 4,
    fill: "#fb4c23",
    cx: 560,
    cy: 150
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    r: 8,
    fill: "#f9173e",
    cx: 536,
    cy: 162.16216216216216
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    r: 3.2,
    fill: "#f9173e",
    cx: 640,
    cy: 200
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    r: 5.2,
    fill: "#dc08ae",
    cx: 104,
    cy: 96
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    r: 3.2,
    fill: "#dc08ae",
    cx: 24,
    cy: 340
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    r: 1.2,
    fill: "#dc08ae",
    cx: 56,
    cy: 336
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    r: 4.8,
    fill: "#dc08ae",
    cx: 440,
    cy: 456
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    r: 3.2,
    fill: "#dc08ae",
    cx: 456,
    cy: 520
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    r: 4.8,
    fill: "#dc08ae",
    cx: 544,
    cy: 460
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    r: 1.6,
    fill: "#dc08ae",
    cx: 584,
    cy: 432
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    r: 2.4,
    fill: "#dc08ae",
    cx: 626,
    cy: 336
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    r: 2.4,
    fill: "#2a148c",
    cx: 400,
    cy: 560
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    r: 3.2,
    fill: "#2a148c",
    cx: 120,
    cy: 520
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    r: 2.8,
    fill: "#2a148c",
    cx: 92,
    cy: 472
  })), _circle20 || (_circle20 = /*#__PURE__*/React.createElement("circle", {
    r: 12,
    fill: "#02aed3",
    cx: 60,
    cy: 424
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 24,
    fill: "#02aed3",
    x: 48,
    y: 412,
    rx: 4
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    ry: 4,
    fill: "#f81f3b",
    x: 432,
    y: 88
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJd);
export default __webpack_public_path__ + "static/media/jd.9b277c0a2fd141819d72c20d609c8a09.svg";
export { ForwardRef as ReactComponent };